import { colors, fontSize, fontFamily, fontWeights, lineHeight } from "./FigmaDesignTokens";

const objectMap = (obj, fn) =>
  Object.fromEntries(Object.entries(obj).map(([k, v], i) => [k, fn(v, k, i)]));

export const Colors = objectMap(colors, (colorValue, colorValueName) => {
  if (colorValue.value) {
    return {
      DEFAULT: colorValue.value,
    };
  } else if (Object.keys(colorValue).length === 1) {
    return {
      DEFAULT: colorValue[Object.keys(colorValue)[0]].value,
    };
  } else {
    const colorData = {
      ...objectMap(colorValue, (subColorValue) => subColorValue.value),
    };

    // Set default by description
    objectMap(colorValue, (subColorValue) => {
      if (subColorValue.description && subColorValue.description.toLowerCase().indexOf('default') != -1) {
        colorData.DEFAULT = subColorValue.value;
      }
    });

    return colorData;
  }
});

export const FontSizes = objectMap(fontSize, (subSize) => `${subSize.value}`);

export const FontWeights = objectMap(fontWeights, (subWeight) => subWeight.value);

export const FontFamilies = objectMap(fontFamily, (subFamily) => [subFamily.value, 'sans-serif']);

export const LineHeights = objectMap(lineHeight, (subHeight) => subHeight.value);
